<div class="w-full h-full">
    <div class="flex items-center justify-between space-x-3 pl-8 pb-5 pr-6 pt-4">
        <div class="flex items-center space-x-3 text-xs">
            <button class="btn-light-orange custom-tabbtn focus:outline-none py-3 px-8 uppercase font-semibold"
                [routerLink]="['/admin/admin-buyload']">
                Buy load
            </button>
            <button class="btn-dark-orange custom-tabbtn focus:outline-none py-3 px-8 uppercase font-semibold"
                [routerLink]="['/admin/admin-tp-pay-bills']">
                pay bills
            </button>
            <button class="btn-light-orange custom-tabbtn focus:outline-none py-3 px-8 uppercase font-semibold"
                [routerLink]="['/admin/admin-tp-cash-in']">
                cash in
            </button>
            <button class="btn-light-orange custom-tabbtn focus:outline-none py-3 px-8 uppercase font-semibold"
                [routerLink]="['/admin/admin-tp-stores']">
                stores
            </button>
            <button class="btn-light-orange custom-tabbtn focus:outline-none py-3 px-8 uppercase font-semibold"
                [routerLink]="['/admin/admin-tp-redeem']">
                redeem
            </button>
        </div>

        <app-tab-header>
            <span 
                matTooltip="Export to Excel" 
                matTooltipPosition="left" 
                matTooltipClass="custom-orange-tooltip">
                <app-print-button (togglePrint)="print()"></app-print-button>
            </span>
        </app-tab-header>

    </div>

    <!-- FILTER FORM -->
    <div class="w-700-px mx-auto">
        <form [formGroup]="form">
            <div class="grid grid-cols-8 gap-3">

                <div class="col-span-8">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <span class="text-xs w-130-px font-semibold">Transaction ID:</span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="transactionId"
                            type="text"
                            placeholder="Transaction ID">
                    </div>
                </div>

                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input class="w-full" label="Date From:" [parentForm]="form"
                            controlName="dateFrom"></app-date-input>
                    </div>
                </div>

                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input class="w-full" label="Date To:" [parentForm]="form"
                            controlName="dateTo"></app-date-input>
                    </div>
                </div>

            </div>
        </form>

        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button (click)="submit()"
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <!-- TABLE -->
    <div *ngIf="showTable">
        <div *ngIf="submitted">

            <app-table-controls
                [currentLimit]="activeLimit?.size ?? 10"
                [showLimitControl]="true"
                [showSearchControl]="true"
                (limitChangeEvent)="activeLimit?.onLimitChange($event)"
                (searchKeyupEvent)="activeSearch?.onSearchKeyup($event)"
                (keydownEvent)="keyDownFunction($event)">
            </app-table-controls>

            <div class="bg-light-orange w-full maxh-550-px px-3 overflow-x-auto w-table">

                <div class="data-table4 mt-3 barlow text-xs" style="font-size: 10px;">

                    <table class="w-full">
                        <thead class="capitalize">
                            <tr>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    TRANSACTION ID
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('transactionId')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    ERROR MESSAGE
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('errorMessage')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    CREATE DATE
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('createDate')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    PROVIDER
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('provider')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    MEGAPAY REQUEST
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('megapayRequest')">
                                </th>
                                <th class="text-left barlow pl-2 pt-3 pb-3">
                                    THIRD PARTY RESPONSE
                                    <img src="../../../../assets/images/icon/sort2.webp" style="height:20px;float:right" (click)="sortList('thirdPartyResponse')">
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr class="focus:outline-none" *ngFor="let item of activeList">
                                <td>{{ item.transactionId ?? '-' }}</td>
                                <td>{{ (item.errorMessage && item.errorMessage !== '0x0000') ? item.errorMessage : 'N/A' }}</td>
                                <td>{{ item.createDate | date:'yyyy-MM-dd' }}</td>
                                <td>{{ item.provider ?? '-' }}</td>
                                <td 
                                    style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    [matTooltip]="item.megapayRequest"
                                    matTooltipClass="custom-orange-tooltip-wide">
                                    {{ item.megapayRequest ?? '-' }}
                                </td>

                                <td 
                                    style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    [matTooltip]="item.thirdPartyResponse"
                                    matTooltipClass="custom-orange-tooltip-wide">
                                    {{ item.thirdPartyResponse ?? '-' }}
                                </td>
                            </tr>

                            <!-- Empty State -->
                            <tr *ngIf="!isLoading && (!activeList || activeList.length === 0)">
                                <td colspan="6" class="text-center py-6">
                                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;">
                                        <img src="../../../../assets/images/icon/no-data.webp"
                                            alt="No Data"
                                            style="height: 48px; opacity: 0.4;"
                                            onerror="this.style.display='none'">
                                        <span class="font-semibold text-xs uppercase tracking-wide text-gray-400">No records found</span>
                                        <span class="italic text-xs text-gray-400">Try adjusting your search or filter criteria.</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <app-pagination
                backgroundColor="bg-light-orange"
                [showTotalEntries]="true"
                [currentPage]="activePage?.current ?? 1"
                [totalPages]="activePage?.total ?? 1"
                [pageSize]="activeLimit?.size ?? 10"
                [totalItems]="activeLimit?.total ?? 0"
                (previousPage)="prevPage()"
                (nextPage)="nextPage()"
                (pageChange)="setPage($event)">
            </app-pagination>
        </div>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>
